import type { ButtonHTMLAttributes, ReactNode } from "react";

export function Button({ variant = "primary", className = "", children, ...props }: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: "primary" | "secondary" | "quiet" | "danger"; children: ReactNode }) {
  return <button className={`button button--${variant} ${className}`} {...props}>{children}</button>;
}

export function ArrowIcon() {
  return <svg aria-hidden="true" viewBox="0 0 24 24" className="arrow-icon"><path d="M5 12h13M13 6l6 6-6 6" /></svg>;
}
